<template>
  <property-report-card
    title="Concessions"
    description="See how your concessions stack up against the competition."
    :printing-mode="printingMode"
  >
    <template #actions>
      <q-btn id="concessions_download" flat no-caps @click="exportCSV">
        <q-icon name="download" class="q-mr-sm" size="medium" />Download
      </q-btn>
      <q-select
        v-model="status"
        transition-duration="100"
        style="width: 150px"
        dense
        outlined
        label="Metric"
        :options="statusOptions"
        @update:model-value="
          (filter) => $tracker.changedFilter('concession_status', 'concessions', filter)
        "
      />
    </template>
    <concessions-table
      id="intercom-concessions-content"
      ref="concessionsTable"
      :concessions="rows"
      :date-range="dateRange"
      :default-status="defaultStatus"
      :printing-mode="printingMode"
    />
  </property-report-card>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { PropertyDetailsResponse, Availability, Price, AvailabilityPeriod } from 'common'
import ConcessionsTable from '@/components/PropertyReports/ConcessionsTable.vue'
import PropertyReportCard from '@/components/PropertyReportCard.vue'
import { getActiveConcessions, unitsFound } from '@/utils'

export default {
  name: 'PropertyCompareConcessions',
  components: { PropertyReportCard, ConcessionsTable },
  props: {
    filteredProperties: {
      type: Array<{
        prop: PropertyDetailsResponse
        units: {
          unit: Availability
          lastHistory: Price
          period: AvailabilityPeriod
        }[]
      }>,
      required: true
    },
    dateRange: {
      type: Object as PropType<{ from: Date; to: Date }>,
      required: true
    },
    defaultStatus: {
      type: String,
      default: 'active'
    },
    printingMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: { value: 'active', label: 'Active' } as { value: string; label: string },
      statusOptions: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Expired' },
        { value: 'all', label: 'All' }
      ]
    }
  },
  computed: {
    rows() {
      return this.filteredProperties.flatMap(({ prop }) => {
        let concessions = prop.concessions_history || []
        if (this.status.value === 'active') {
          concessions = getActiveConcessions(prop)
        } else if (this.status.value === 'inactive') {
          concessions = concessions.filter((concession) => concession.to_date < prop.created_on)
        }
        return concessions.map((c) => ({ prop, concession: c }))
      })
    }
  },
  created() {
    this.status = this.statusOptions.find((_) => _.value === this.defaultStatus)!
  },
  methods: {
    unitsFound,
    exportCSV() {
      // call export CSV frm concessionsTable component
      this.$refs.concessionsTable.exportCSV()
    }
  }
}
</script>
